import { useState } from 'react'

import { useToasts } from '@/hooks/useToasts'

import { MAX_INCIDENT_FILES } from '../utils/constants'

export const useIncidentFileSelect = () => {
  const [selectedFiles, setSelectedFiles] = useState<File[]>([])
  const { showError } = useToasts()

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || [])
    const remainingCapacity = MAX_INCIDENT_FILES - selectedFiles.length

    if (files.length > remainingCapacity) {
      showError(`You can only add up to ${MAX_INCIDENT_FILES} files`)
      return
    }

    const newFiles = files.filter(
      (file) =>
        !selectedFiles.some((selectedFile) => selectedFile.name === file.name)
    )

    if (newFiles.length < files.length) {
      showError('Some files were already added and were skipped')
    }

    setSelectedFiles((prevFiles) => [...prevFiles, ...newFiles])
  }

  const removeFile = (fileToRemove: File) => {
    setSelectedFiles((prevFiles) =>
      prevFiles.filter((file) => file.name !== fileToRemove.name)
    )
  }

  return {
    selectedFiles,
    handleFileSelect,
    removeFile,
    clearFiles: () => setSelectedFiles([]),
  }
}
